( function ( _s ) {
	_s.fn.filtersToggle = function () {
		return this.each( el => {
			const _self = _s( el );
			const _body = _self.closest( 'body' );
			const _filters = _s( '#' + _self.attr( 'filters-id' ) );
			const _showFilters = _self.find( '.show-filters' );
			const _hideFilters = _self.find( '.hide-filters' );

			/** Search form placed beside filters toggle button */
			const _filtersToggleSearch = _self.find( '.search' );
			const _filtersToggleSearchTextInput =
				_filtersToggleSearch.find( 'input[name="search"]' );

			/** Search input from the card grid filters */
			const _searchFilter = _filters.find( '.search-input' );

			let filtersVisible = false;

			const getMainContainer = () => {
				let _mainContainer = _self.closest( '.card-grid-with-filters-module' );

				if ( ! _mainContainer.length ) {
					_mainContainer = _self.closest( 'header.banner' );
				}

				return _mainContainer;
			};

			const _mainFiltersContainer = getMainContainer();

			const toggleFilters = addClass => {
				_mainFiltersContainer.toggleClass( 'filters-visible', addClass );
				_body.toggleClass( 'overflow-hidden', addClass );
				filtersVisible = addClass;
			};

			/** Set the search input value */
			const setInitialSearchValue = () => {
				if ( _searchFilter.length && _filtersToggleSearchTextInput.length ) {
					_filtersToggleSearchTextInput.firstElement().value =
						_searchFilter.firstElement().value;
				}
			};

			_showFilters.on( 'click', () => {
				toggleFilters( true );
			} );

			_hideFilters.on( 'click', () => {
				toggleFilters( false );
			} );

			_filtersToggleSearch.on( 'submit', e => {
				e.preventDefault();

				if ( _filtersToggleSearchTextInput.length ) {
					const searchText = _filtersToggleSearchTextInput.firstElement().value;

					_searchFilter.each( search => {
						search.value = searchText;
						_filters.firstElement().submit();
					} );
				}
			} );

			_filters.on( 'submit', () => {
				if ( _searchFilter.length && _filtersToggleSearchTextInput.length ) {
					_filtersToggleSearchTextInput.firstElement().value =
						_searchFilter.firstElement().value;
				}
			} );

			_filtersToggleSearchTextInput.on( 'change', () => {
				if ( _searchFilter.length ) {
					_searchFilter.firstElement().value =
						_filtersToggleSearchTextInput.firstElement().value;
				}
			} );

			_searchFilter.on( 'change', () => {
				if ( _filtersToggleSearchTextInput.length ) {
					_filtersToggleSearchTextInput.firstElement().value =
						_searchFilter.firstElement().value;
				}
			} );

			_self.on( 'sp:hide-filters', () => {
				toggleFilters( false );
			} );

			_s( window ).on(
				'resize',
				window.debounce( () => {
					if (
						filtersVisible &&
						! [ 'xs', 'sm' ].includes( window.currentBreakpoint() )
					) {
						toggleFilters( false );
					}
				}, 200 )
			);

			setInitialSearchValue();
		} );
	};

	_s( document ).ready( () => {
		_s( '.filters-toggle' ).filtersToggle();
	} );
} )( window._s );
